// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}

.price {
  font-size: 14px;
  color: black;
  font-family: AppFontBold, sans-serif;
  margin-right: 10px;
}

ion-label {
  font-size: 14px;
}
@media (min-width: 991px) {
  ion-label {
    padding-right: 5px;
  }
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #ffffff;
  border: 0.5px solid #e2dcd5;
  border-radius: 10px;
  margin: 10px 0px;
  margin-bottom: 6px;
  --inner-padding-end: 2px;
  padding: 0 10px;
}

.item-img {
  width: 50px;
  padding: 7px;
}

ion-checkbox {
  margin: 0 12px 0 0;
}

ion-checkbox::part(container) {
  border: none;
  background: url('add-plus.svg') no-repeat center center/100% 100%;
  background-size: contain;
}

ion-checkbox.checkbox-checked::part(container) {
  background: var(--ion-color-primary);
  border-color: transparent;
  border-radius: 50%;
}

.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  color: #1a1a18 !important;
  font-family: AppFont, sans-serif;
  display: flex;
}

.mehr-articles {
  width: -moz-fit-content;
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}

.content-only {
  vertical-align: bottom;
  height: 18px;
  width: 18px;
  padding: 0;
  margin-left: 3px;
}

.base-price {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox-item/article-option-group-checkbox-item.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,cAAA;AAAD;;AAGA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAAD;;AAGA;EACC,eAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AAAD;;AAGA;EACC,eAAA;AAAD;ACnBE;EDkBF;IAGE,kBAAA;EAEA;AACF;;AACA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AAED;;AACA;EACC,qBAAA;AAED;;AAAA;EACC,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;AAGD;;AAAA;EACC,WAAA;EACA,YAAA;AAGD;;AAAA;EACC,kBAAA;AAGD;;AAAA;EACC,YAAA;EACA,iEAAA;EACA,wBAAA;AAGD;;AAAA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;AAGD;;AAAA;EACC,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAGD;AADC;EACC,yBAAA;EAEA,gCAAA;EACA,aAAA;AAEF;;AACA;EACC,uBAAA;EAAA,kBAAA;AAED;AADC;EACC,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAGF;AAFE;EACC,kBAAA;AAIH;AAFE;EACC,YAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AAIH;AAHG;EACC,cAAA;AAKJ;;AACA;EACC,sBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAED;;AACA;EACC,eAAA;AAED","sourcesContent":["@import '../../../../theme/mixins';\n:host {\n\tdisplay: block;\n}\n\nion-radio-group {\n\twidth: 100%;\n\tborder-radius: 0px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\n.price {\n\tfont-size: 14px;\n\tcolor: black;\n\tfont-family: AppFontBold, sans-serif;\n\tmargin-right: 10px;\n}\n\nion-label {\n\tfont-size: 14px;\n\t@include desktop {\n\t\tpadding-right: 5px;\n\t}\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder: 0.5px solid #e2dcd5;\n\tborder-radius: 10px;\n\tmargin: 10px 0px;\n\tmargin-bottom: 6px;\n\t--inner-padding-end: 2px;\n\tpadding: 0 10px;\n}\n\n.item-img {\n\twidth: 50px;\n\tpadding: 7px;\n}\n\nion-checkbox {\n\tmargin: 0 12px 0 0;\n}\n\nion-checkbox::part(container) {\n\tborder: none;\n\tbackground: url('../../../../assets/losteria/add-plus.svg') no-repeat center center/ 100% 100%;\n\tbackground-size: contain;\n}\n\nion-checkbox.checkbox-checked::part(container) {\n\tbackground: var(--ion-color-primary);\n\tborder-color: transparent;\n\tborder-radius: 50%;\n}\n\n.text_wrap {\n\ttext-align: left;\n\ttext-wrap: wrap;\n\twhite-space: normal;\n\tword-break: break-word;\n\n\tspan {\n\t\tcolor: #1a1a18 !important;\n\n\t\tfont-family: AppFont, sans-serif;\n\t\tdisplay: flex;\n\t}\n}\n.mehr-articles {\n\twidth: fit-content;\n\tdiv {\n\t\tbackground: white;\n\t\tborder: 1px solid black;\n\t\tpadding: 5px 10px;\n\t\tborder-radius: 25px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\th3 {\n\t\t\tmargin-right: 20px;\n\t\t}\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t\tmargin-left: 15px;\n\t\t\trotate: 0deg;\n\t\t\ttransition: rotate 0.7s;\n\t\t\t&.rotate {\n\t\t\t\trotate: 180deg;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.content-only {\n\tvertical-align: bottom;\n\theight: 18px;\n\twidth: 18px;\n\tpadding: 0;\n\tmargin-left: 3px;\n}\n\n.base-price {\n\tfont-size: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
